{
  "buttons": {
    "primaryAction": {
      "next": "Next",
      "save": "Save"
    }
  },
  "steps": {
    "type": {
      "title": "Contact Type",
      "header": "What type of contacts are in this group?",
      "description": "Select the type of contacts.",
      "options": {
        "camper": "Parent of Camper",
        "staff": "Camp Staff"
      }
    }
  }
}
